import React from 'react';
import styles from './W_PaymentCard.module.css';
import A_CardInput from '@/components/A_Atoms/A_CardInput/A_CardInput';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

export default function W_PaymentCard() {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);

  return (
    <div className={styles.wrapper}>
      <h4 className={styles.title}>{t('payment.card.attachCard')}</h4>
      <A_CardInput />
    </div>
  );
}
